/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Note_AddedInputs */

const en_case_history_headline_note_added = /** @type {(inputs: Case_History_Headline_Note_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added a note`)
};

const pt_br2_case_history_headline_note_added = /** @type {(inputs: Case_History_Headline_Note_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionou nota`)
};

/**
* | output |
* | --- |
* | "Added a note" |
*
* @param {Case_History_Headline_Note_AddedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_note_added = /** @type {((inputs?: Case_History_Headline_Note_AddedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Note_AddedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_note_added(inputs)
	return pt_br2_case_history_headline_note_added(inputs)
});